import initParticleParallax from './visualEffects/initParticleParallax';
import initHeroParallax from './visualEffects/initHeroParallax';
import initBackgroundImagesParallax from './visualEffects/initBackgroundImagesParallax';

export default function () {
  initParticleParallax();
  initHeroParallax();
  initBackgroundImagesParallax();
}
